import { render } from "../templates/card-instrument.html?vue&type=template&id=2a26977f"
import script from "./card-instrument.vue?vue&type=script&lang=js"
export * from "./card-instrument.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__